import styled from 'styled-components';

export const MedicareLink = styled.div`
  button {
    width: 256px !important;
    height: 48px !important;
  }
`;
